import { LAYOUT, MENU_BEHAVIOUR, NAV_COLOR, MENU_PLACEMENT, RADIUS, THEME_COLOR, USER_ROLE } from 'constants.js';

export const IS_DEMO = false;
export const IS_AUTH_GUARD_ACTIVE = true;
export const SERVICE_URL = '/app';
export const USE_MULTI_LANGUAGE = false;

// For detailed information: https://github.com/nfl/react-helmet#reference-guide
export const REACT_HELMET_PROPS = {
  defaultTitle: 'Autopaquete',
  titleTemplate: '%s | Autopaquete',
};

export const DEFAULT_PATHS = {
  APP: '/',
  LOGIN: '/login',
  LOGINADMIN: '/login-admin',
  REGISTER: '/register',
  VERIFICATION: '/verify-code',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  // USER_WELCOME: '/dashboards/default',
  NOTFOUND: '/page-not-found',
  UNAUTHORIZED: '/unauthorized',
  // INVALID_ACCESS: '/invalid-access',
};

export const DEFAULT_SETTINGS = {
  MENU_PLACEMENT: MENU_PLACEMENT.Vertical,
  MENU_BEHAVIOUR: MENU_BEHAVIOUR.Pinned,
  LAYOUT: LAYOUT.Boxed,
  RADIUS: RADIUS.Rounded,
  COLOR: THEME_COLOR.LightRed,
  NAV_COLOR: NAV_COLOR.Default,
  USE_SIDEBAR: false,
};

export const DEFAULT_USER = {
  name: 'Firulais',
  thumb: '/img/profile/profile-5.webp',
  role: USER_ROLE.User,
  email: 'lisajackson@gmail.com',
  razon_social: 'Autopaquete Servicios',
  crmId: 'A00000',
  multipieces: false,
  isVerified: false,
};

export const REDUX_PERSIST_KEY = 'starter-project';
